import Icon from "/components/common/icon";
import { popupTypes } from "/redux/reducers/popupReducer";
import { showPopup } from "/redux/action-creaters/popup";
import { useDispatch, useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { useRouter } from "next/router";
import { GOALS, reachGoal } from "../../../utils/tracking";
import { isBackFormHidden } from "../../../utils/abTestsClient";
import styles from "./index.module.scss";
import { splitGifts } from "~/utils/cartGifts";

export default function BackForm({ basket, contacts }) {
  const dispatch = useDispatch();
  const { visibleType } = useSelector((state) => state.popup);
  const { user } = useSelector((state) => state.user);
  const [isShow, setIsShow] = useState(true);

  const isShowCart = useMemo(() => {
    if (typeof window === "object") {
      return !window.location.href.includes("cart");
    }
    return false;
  }, [contacts]);

  const items = [
    {
      name: "Заказать звонок",
      icon: "backformcall",
      popupCode: popupTypes.backCall,
      mobileTargetElementId: "phoneLink",
      testTag: "backCallFormButton",
    },
    {
      name: "Max",
      icon: "max",
      targetElementId: "maxLink",
    },
    {
      name: "Telegram",
      icon: "tg",
      targetElementId: "tgLink",
    },
    /* {
            name: 'Видеоконсультация',
            icon: 'backformvideo',
            popupCode: popupTypes.videoConsultation,
        }, */
    {
      name: "Написать нам",
      icon: "vk",
      link: "https://vk.com/farkopru",
    },
    /* {
            name: 'Похвалить',
            icon: 'backformlike',
            popupCode: popupTypes.like,
        },
        {
            name: 'Пожаловаться',
            icon: 'backformdislike',
            popupCode: popupTypes.dislike,
        } */
  ];

  const router = useRouter();
  const cnt = useMemo(() => {
    return splitGifts(basket).qty;
  }, [basket]);

  return (
    visibleType === popupTypes.none &&
    !isBackFormHidden() && (
      <div className={styles.BackForm}>
        {isShow ? (
          <div
            className={styles.Close}
            onClick={() => setIsShow(false)}
            aria-label="Скрыть меню быстрых действий"
          >
            <Icon id={"backformclose"} size={22} fill={"#000"} />
          </div>
        ) : (
          <div
            className={styles.Show}
            onClick={() => setIsShow(true)}
            aria-label="Показать меню быстрых действий"
          >
            <Icon id={"backformquestion"} size={22} />
          </div>
        )}

        {isShow && (
          <div className={styles.Items}>
            {items.map((item) => (
              <div
                key={item.icon}
                data-test={item.testTag}
                className={styles.Item}
                onClick={() => {
                  // Проверяем, кликают ли вообще по нижней мобильной панели
                  // соцсетей: на десктопе это боковое меню, цель не нужна.
                  if (window.innerWidth <= 991) {
                    reachGoal(GOALS.mobileBottomSocClick, user);
                  }
                  if (window.innerWidth < 991 && item.mobileTargetElementId) {
                    document
                      .getElementById(item.mobileTargetElementId)
                      ?.click();
                  } else if (item.targetElementId) {
                    document.getElementById(item.targetElementId)?.click();
                  } else if (item.link) {
                    window.open(item.link, "_blank");
                  } else if (item.popupCode) {
                    dispatch(showPopup(item.popupCode));
                  }
                }}
                aria-label={item.name}
              >
                <div>
                  <span>{item.name}</span>
                  <div className={styles.Icon}>
                    <Icon id={item.icon} size={22} />
                  </div>
                </div>
              </div>
            ))}

            {isShowCart && (
              <div
                className={styles.Cart}
                onClick={() => {
                  if (cnt === 0) {
                    dispatch(showPopup(popupTypes.cartEmpty));
                  } else {
                    router.push("/personal/cart/");
                  }
                }}
                aria-label="Открыть корзину"
              >
                <div className={styles.Icon}>
                  <Icon
                    id="cart"
                    width={22}
                    height={22}
                    stroke={"#2f69ff"}
                    strokeWidth={2}
                  />
                  {cnt > 0 && <span>{cnt}</span>}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  );
}
